export const zeroPad = (num: number, places: number) => String(num).padStart(places, '0');
